// extracted by mini-css-extract-plugin
module.exports = {"container":"_772e1b1e50--container--C7hn2","background":"_772e1b1e50--background--KV7Ke","image":"_772e1b1e50--image--xN0Ub","footnote":"_772e1b1e50--footnote--TDQy5"};